var __extends = (this && this.__extends) || function (d, b) {
    for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p];
    function __() { this.constructor = d; }
    d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
};
define('areas/navigationmanager/parts/creategroup',["require", "exports", "common/parts", "areas/navigationmanager/models/bindable", "areas/navigationmanager/services/mappings"], function (require, exports, Parts, Model, Mapping) {
    "use strict";
    var CreateGroup = (function (_super) {
        __extends(CreateGroup, _super);
        function CreateGroup(target) {
            _super.call(this);
            this._nodeAccessor = target;
        }
        CreateGroup.prototype.process = function (symbol) {
            try {
                var currentNode = this._nodeAccessor();
                // Create default group
                var defaultGroup = Model.NavigationGroupVM.createDefaultGroup();
                // Check if key of default group exist in current navigation node list
                if (Enumerable.From(currentNode.groups).FirstOrDefault(null, function (_) { return _.key == defaultGroup.key; }) !== null)
                    throw new Error("Group with key: 'Default-Key' exist into groups list! See list of groups.");
                // Map default group
                var group = Mapping.parseGroup(defaultGroup);
                currentNode.groups.push(group);
                this.output.call(group);
            }
            catch (error) {
                this.error.call(error);
            }
        };
        return CreateGroup;
    }(Parts.Part));
    return CreateGroup;
});

